import React from 'react';

import Radio from 'components/shared/Radio/Radio';
import DisclosureModal from 'components/shared/Disclosure/DisclosureModal';

const AlertsAndNotificationsTableRow = ({
  label,
  onChange,
  selection,
  options,
  name,
  content
}) => {
  return (
    <div className="alerts-and-notifications-activity-alerts-table-body-text">
      <div className="alerts-and-notifications-radio-label">
        {label}
        <DisclosureModal content={content} title={label} hideLinkContent />
      </div>
      <div className="alerts-and-notifications-activity-alerts-table-body-radio-container">
        {options &&
          options.map((option) => {
            return (
              <Radio
                onChange={onChange}
                key={name + option.value}
                checked={option.value === selection}
                value={option.value}
                name={name}
              />
            );
          })}
      </div>
    </div>
  );
};

export default AlertsAndNotificationsTableRow;
